import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { APIURLs } from '../api-urls';
import { SharedService } from '../shared/shared.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../api-urls";
import * as i3 from "../shared/shared.service";
/** Service Injectable */
var CommonService = /** @class */ (function () {
    /**
     * Method to initialize Service
     * @param http instance of HttpClient
     * @param urls instance of APIURLs
     * @param shared instance of SharedService
     */
    function CommonService(http, urls, shared) {
        this.http = http;
        this.urls = urls;
        this.shared = shared;
    }
    /** show loader */
    CommonService.prototype.showLoader = function (message) {
        this.shared.isServiceHit = true;
        this.shared.loadingMessage = (message ? message.split('.').join('') : "") || "";
    };
    /** Hide Loader */
    CommonService.prototype.hideLoader = function () {
        this.shared.loadingMessage = "";
        this.shared.isServiceHit = false;
    };
    /**
     * Rest API to Sned Support Email
     * @param request request to send
     * @param businessUnit Current Business Unit
     */
    CommonService.prototype.supportEmail = function (request, businessUnit) {
        var _this = this;
        var url = this.urls.getSupportURL(businessUnit);
        this.showLoader("Sending support mail..");
        return this.http.post(url, request).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    CommonService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CommonService_Factory() { return new CommonService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.APIURLs), i0.ɵɵinject(i3.SharedService)); }, token: CommonService, providedIn: "root" });
    return CommonService;
}());
export { CommonService };
